export const LISTENER_ROUTES_CARD_ID_CHANNEL = "LISTENER_ROUTES_CARD_ID_CHANNEL"
export const LISTENER_ROUTES_CARD_ID_CHANNEL_SUCCESS = "LISTENER_ROUTES_CARD_ID_CHANNEL_SUCCESS"

export const LISTENER_ROUTES_CHANNEL_BY_ID_COMPANY = "LISTENER_ROUTES_CHANNEL_BY_ID_COMPANY"
export const LISTENER_ROUTES_CHANNEL_BY_ID_COMPANY_SUCCESS = "LISTENER_ROUTES_CHANNEL_BY_ID_COMPANY_SUCCESS"

export const ROUTES_CHANNEL_ERROR = "FIND_OR_EDIT_ROUTES_CHANNEL_ERROR"
